<section class="connect-page">

  <div class="connect-grid">
    <mat-card class="connect-card">
      <mat-card-header>
        <div class="card-title-row">
            <div>
                <p class="connect-section-title">Connections</p>
                <p class="connect-subtitle">Create, edit, re-auth, or delete connections.</p>
            </div>
          <div class="card-actions">
            <button mat-stroked-button color="primary" (click)="toggleCreate()" [disabled]="loadingProviders">
              {{ showCreate ? 'Hide form' : 'Create connection' }}
            </button>
            <button mat-button color="primary" (click)="loadConnections()" [disabled]="loadingConnections">
              {{ loadingConnections ? 'Refreshing…' : 'Refresh' }}
            </button>
          </div>
        </div>
      </mat-card-header>

      <mat-card-content class="connections-body">
        @if (error) {
          <div class="error-banner">{{ error }}</div>
        }

        @if (showCreate) {
          <form class="connection-form create-form" [formGroup]="createForm" (ngSubmit)="createConnection()">
            <div class="form-grid">
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" placeholder="HubSpot CRM" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Provider</mat-label>
                <mat-select formControlName="providerId" (selectionChange)="onProviderChanged($event.value)">
                    <mat-option value="">Custom</mat-option>
                  @for (provider of providers; track provider.id) {
                      <mat-option [value]="provider.id">{{ provider.name }} ({{ provider.ref }})</mat-option>
                  }
                </mat-select>
              </mat-form-field>

                @if (createForm.value.providerId) {
                    <div class="docs-link">
                        <a [href]="providerDocsUrl(createForm.value.providerId)" rel="noreferrer"
                           target="_blank">Docs</a>
                    </div>
                }

                @if (!createForm.value.providerId) {
                    <mat-form-field appearance="outline">
                        <mat-label>Provider ref</mat-label>
                        <input formControlName="ref" matInput placeholder="custom.oauth2"/>
                        <mat-hint>Used for Connect validation and OAuth; defaults to custom.&lt;authType&gt;.</mat-hint>
                    </mat-form-field>
                }

                <mat-form-field appearance="outline">
                <mat-label>Region</mat-label>
                <mat-select formControlName="region">
                  <mat-option value="eu">EU</mat-option>
                  <mat-option value="us">US</mat-option>
                  <mat-option value="auto">Auto</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Auth type</mat-label>
                <mat-select formControlName="authType" (selectionChange)="setCreateAuthType($event.value)">
                  @for (option of authOptions(createForm.value.providerId || undefined); track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (providerDescription(createForm.value.providerId); as description) {<p class="connect-muted small">{{description}}</p>}
            @if (connectionHelp(createForm.value.providerId, createForm.value.authType); as guide) {
              <app-connect-connection-help [guide]="guide" />
            }
            <div class="auth-grid">
              @if (createForm.value.authType === 'oauth2') {
                <div class="full">
                  <button mat-stroked-button color="primary" type="button" (click)="authenticateNew()" [disabled]="authenticatingId !== null">
                    {{ authenticatingId === 'new' ? 'Waiting for auth…' : 'Authenticate' }}
                  </button>
                  <p class="connect-muted small">Shine manages application credentials securely. Authenticate to authorize this connection.</p>
                </div>
              }
              @if (createForm.value.authType === 'api_key') {
                @if (!apiKeySettings(createForm.value.providerId)) {
                <mat-form-field appearance="outline">
                  <mat-label>Header name</mat-label>
                  <input matInput formControlName="apiKeyName" placeholder="x-api-key" />
                </mat-form-field>
                }
                <mat-form-field appearance="outline">
                  <mat-label>Key value</mat-label>
                  <input matInput type="password" formControlName="apiKeyValue" [placeholder]="maskSecret(createForm.value.apiKeyValue)" />
                </mat-form-field>
                @if (apiKeySettings(createForm.value.providerId); as settings) {<p class="connect-muted small">{{settings.help_text}}</p>}
              }
              @if (createForm.value.authType === 'bearer') {
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Bearer token</mat-label>
                  <input matInput type="password" formControlName="bearerToken" [placeholder]="maskSecret(createForm.value.bearerToken)" />
                </mat-form-field>
              }
              @if (createForm.value.authType === 'basic') {
                <mat-form-field appearance="outline">
                  <mat-label>Username</mat-label>
                  <input matInput formControlName="basicUsername" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input matInput type="password" formControlName="basicPassword" [placeholder]="maskSecret(createForm.value.basicPassword)" />
                </mat-form-field>
              }
              @if (createForm.value.authType === 'custom') {
                <mat-form-field appearance="outline">
                  <mat-label>Host</mat-label>
                  <input matInput formControlName="customHost" placeholder="sftp.example.com" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Port</mat-label>
                  <input matInput type="number" formControlName="customPort" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Username</mat-label>
                  <input matInput formControlName="customUsername" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input matInput type="password" formControlName="customPassword" [placeholder]="maskSecret(createForm.value.customPassword)" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Private key (PEM)</mat-label>
                  <textarea matInput rows="3" formControlName="customPrivateKey" [placeholder]="maskSecret(createForm.value.customPrivateKey) || '********'"></textarea>
                </mat-form-field>
              }
            </div>

            <div class="form-actions">
              <span class="connect-muted small">Config uses the same connection-v1 schema as Connect.</span>
              <span class="spacer"></span>
              <button mat-flat-button color="primary" type="submit" [disabled]="createBusy || authenticatingId !== null">
                {{ createBusy ? 'Creating…' : 'Create connection' }}
              </button>
            </div>
          </form>
        }

        <div class="table-wrapper">
          @if (loadingConnections) {
            <div class="loading-row">
              <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
              <span class="connect-muted">Loading connections...</span>
            </div>
          } @else if (connections.length === 0) {
            <p class="connect-muted">No connections yet. Add one to reuse across workflows.</p>
          } @else {
            <div class="table-head">
              <span>Name</span>
              <span>Type</span>
              <span>Status</span>
                <span class="actions-col">Edit</span>
                <span class="actions-col">Delete</span>
            </div>
            @for (conn of connections; track conn.id) {
              <div class="table-row">
                <div>
                  <div class="row-top">
                    <span class="workflow-title">{{ conn.name }}</span>
                  </div>
                  <div class="connection-meta">
                      <span class="connect-muted">{{ providerLabel(conn) }}</span>
                  </div>
                </div>
                  <span class="connect-muted">{{ typeLabel(conn.config?.['type']) }}</span>
                  <span [ngClass]="badgeFor(conn).className">{{ badgeFor(conn).label }}</span>
                <div class="row-actions">
                  <button mat-stroked-button color="primary" (click)="toggleEdit(conn)">
                    {{ isEditOpen(conn.id) ? 'Close' : 'Edit' }}
                  </button>
                </div>
                  <div class="row-actions">
                  <button mat-button color="warn" (click)="delete(conn.id)" [disabled]="isSaving(conn.id)">Delete</button>
                </div>
              </div>

              @if (isEditOpen(conn.id) && editForm(conn.id); as form) {
                <div class="edit-panel" [formGroup]="form">
                  <div class="form-grid tight">
                    <mat-form-field appearance="outline">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="name" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Provider</mat-label>
                        <mat-select (selectionChange)="onEditProviderChanged(conn.id, $event.value)"
                                    formControlName="providerId">
                            <mat-option value="">Custom</mat-option>
                            @for (provider of providers; track provider.id) {
                                <mat-option [value]="provider.id">{{ provider.name }} ({{ provider.ref }})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                      @if (form.value['providerId']) {
                          <div class="docs-link">
                              <a [href]="providerDocsUrl(form.value['providerId'])" rel="noreferrer" target="_blank">Docs</a>
                          </div>
                      }

                      @if (!form.value['providerId']) {
                          <mat-form-field appearance="outline">
                              <mat-label>Provider ref</mat-label>
                              <input formControlName="ref" matInput placeholder="custom.oauth2"/>
                              <mat-hint>Used for Connect validation and OAuth; defaults to custom.&lt;authType&gt;.
                              </mat-hint>
                          </mat-form-field>
                      }
                    <mat-form-field appearance="outline">
                      <mat-label>Region</mat-label>
                      <mat-select formControlName="region">
                        <mat-option value="eu">EU</mat-option>
                        <mat-option value="us">US</mat-option>
                        <mat-option value="auto">Auto</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Auth type</mat-label>
                      <mat-select formControlName="authType" (selectionChange)="setEditAuthType(conn.id, $event.value)">
                          @for (option of authOptions(form.value['providerId'] || undefined); track option.value) {
                              <mat-option [value]="option.value">{{ option.label }}</mat-option>
                          }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  @if (providerDescription(form.value['providerId']); as description) {<p class="connect-muted small">{{description}}</p>}
                  @if (connectionHelp(form.value['providerId'], form.value['authType']); as guide) {
                    <app-connect-connection-help [guide]="guide" [editing]="true" />
                  }
                  <div class="auth-grid">
                    @if (form.value['authType'] === 'oauth2') {
                      <div class="full">
                        <button mat-stroked-button color="primary" type="button" (click)="authenticateExisting(conn)" [disabled]="authenticatingId !== null">
                          {{ authenticatingId === conn.id ? 'Waiting for auth…' : 'Re-authenticate' }}
                        </button>
                        <p class="connect-muted small">Keeps existing refresh token if none is provided.</p>
                      </div>
                    }
                    @if (form.value['authType'] === 'api_key') {
                      @if (!apiKeySettings(form.value['providerId'])) {
                      <mat-form-field appearance="outline">
                        <mat-label>Header name</mat-label>
                        <input matInput formControlName="apiKeyName" />
                      </mat-form-field>
                      }
                      <mat-form-field appearance="outline">
                        <mat-label>Key value</mat-label>
                        <input matInput type="password" formControlName="apiKeyValue" [placeholder]="maskSecret(form.value['apiKeyValue'])" />
                      </mat-form-field>
                      @if (apiKeySettings(form.value['providerId']); as settings) {<p class="connect-muted small">{{settings.help_text}}</p>}
                    }
                    @if (form.value['authType'] === 'bearer') {
                      <mat-form-field appearance="outline" class="full">
                        <mat-label>Bearer token</mat-label>
                        <input matInput type="password" formControlName="bearerToken" [placeholder]="maskSecret(form.value['bearerToken'])" />
                      </mat-form-field>
                    }
                    @if (form.value['authType'] === 'basic') {
                      <mat-form-field appearance="outline">
                        <mat-label>Username</mat-label>
                        <input matInput formControlName="basicUsername" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput type="password" formControlName="basicPassword" [placeholder]="maskSecret(form.value['basicPassword'])" />
                      </mat-form-field>
                    }
                    @if (form.value['authType'] === 'custom') {
                      <mat-form-field appearance="outline">
                        <mat-label>Host</mat-label>
                        <input matInput formControlName="customHost" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Port</mat-label>
                        <input matInput type="number" formControlName="customPort" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Username</mat-label>
                        <input matInput formControlName="customUsername" />
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput type="password" formControlName="customPassword" [placeholder]="maskSecret(form.value['customPassword'])" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="full">
                        <mat-label>Private key (PEM)</mat-label>
                        <textarea matInput rows="3" formControlName="customPrivateKey" [placeholder]="maskSecret(form.value['customPrivateKey']) || '********'"></textarea>
                      </mat-form-field>
                    }
                  </div>

                  <div class="form-actions">
                    <div class="left-meta">
                      <span class="connect-muted small">Saving keeps config in connection-v1 shape.</span>
                    </div>
                    <div class="row-actions">
                      <button mat-button color="primary" (click)="saveEdit(conn)" [disabled]="isSaving(conn.id)">
                        {{ isSaving(conn.id) ? 'Saving…' : 'Save' }}
                      </button>
                      <button mat-stroked-button color="accent" type="button" (click)="toggleEdit(conn)">Close</button>
                    </div>
                  </div>
                </div>
              }
            }
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</section>
